










 

 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationPicker_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiscussionMentioned_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "KickedOut_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentRejected_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskInvolves_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PromoteToBillingLeader_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamArchived_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamInvitationNotification_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingStageTimeLimitEnd_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ResponseMentioned_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Mentioned_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ResponseReplied_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamsLimitExceededNotification_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamsLimitReminderNotification_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PromptToJoinOrgNotification_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestToJoinOrgNotification_notification"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "KudosReceivedNotification_notification"
    }
  ],
  "type": "Notification",
  "abstractKey": "__isNotification"
};

(node ).hash = "760bb2526a84b61ae000aa01d9a6b95e";

export default node;
